import main from './main';

const themes = {
    main
};

export default themes;



// WEBPACK FOOTER //
// ./src/utils/themes/index.js